<template>
  <div class="inputBoxWrap">
    <label>{{item.title}}<br/>
      <suggestions
        v-model="value"
        :options="options"
        :onInputChange="onInputChange"
        :onItemSelected="onSearchItemSelected"
      >
        <div slot="item" slot-scope="props" class="single-item">
          <span class="name">{{returnAdressPart(props.item.data)}}</span>
        </div>
      </suggestions>
    </label>


  </div>
</template>

<script>
  import 'v-suggestions/dist/v-suggestions.css';
  import DataForInput from '@/store/Form/mobileDadata';
  import {mapState, mapGetters} from 'vuex';

  export default {
    name: "vmSelectDadata",
    props:{
      refs: {
        type: String,
        default: 'null'
      },
      itemField:{
        type:String,
        default: '',
      }
    },
    data() {
      return {
        query:'',
        selectedCountry: null,
        selectedSearchItem: null,
        options: {
          // placeholder: DataForInput[this.refs].placeholder,
        },
        item: DataForInput.items[this.itemField],
      }
    },
    computed:{
      ...mapState({
        statusVuex: state => state.Form.workData,
        valueVuex: state => state.Form.sendData,
      }),
      ...mapGetters(['getMobileAdressSuggestion']),
      value:{
        get(){
          try{
            let partAdress = this.valueVuex[this.refs + '_DADATA'];
            let newValue = partAdress.data[this.itemField] == null ? '': partAdress.data[this.itemField];
            let utiputi = {
              target:this.refs,
              adresPart:this.itemField,
              value: newValue
            };
            this.$store.dispatch('setMobileAdressSuggestion',utiputi);
            return newValue;
          }catch (e) {
            return '';
          }

        },
        set(value){
          let utiputi = {
            target:this.refs,
            adresPart:this.itemField,
            value: value
          };
          this.$store.dispatch('setMobileAdressSuggestion',utiputi);
          this.$store.dispatch('saveSendData',utiputi);
        }
      },
      errorMsg(){
        return this.statusVuex[this.refs].msg;
      },
    },
    components: {
      suggestions:()=>import('v-suggestions')
    },
    methods:{
      returnAdressPart(adressObj){
      let preReturn = '';
        switch (this.itemField) {
          case 'area':
            preReturn += (adressObj['region_with_type'] != null) ? adressObj['region_with_type']: '';
            preReturn += (adressObj['area_with_type'] != null) ? ' ' + adressObj['area_with_type']: '';
            break;
          case 'city':
            preReturn += (adressObj['city_with_type'] != null) ? adressObj['city_with_type']: '';
            preReturn +=(adressObj['settlement_with_type'] != null) ? ' ' + adressObj['settlement_with_type']: '';
            break;
          default:
            preReturn = adressObj[this.itemField];
            break;
        }
        return preReturn;
      },
      onInputChange (query) {

        if (query.trim().length === 0) {
          return null
        }
        let utiputi = {
          target:this.refs,
          adresPart:this.itemField,
          value: query
        };
        this.$store.dispatch('setMobileAdressSuggestion',utiputi);
        this.$store.dispatch('saveSendData',utiputi);

        // console.log(this.getMobileAdressSuggestion(this.refs));
        // return the matching countries as an array
        return new Promise(resolve => {
          this.$myApi.suggestResult('Dadata_getSuggest', this.getMobileAdressSuggestion(this.refs).trim()).then(resp => {
            let dadataSuggest = resp;
            let result = (Array.isArray(dadataSuggest) && dadataSuggest.length) ? dadataSuggest : [];
            resolve(result);
          });
        });
      },
      onSearchItemSelected (item) {
        this.selectedSearchItem = item;
        this.query = item.value;
        this.$store.dispatch('saveSendData',{
          target: this.refs,
          value: item.value,
        });
        this.$store.dispatch('saveSendData',{
          target: this.refs + '_DADATA',
          value: item,
        });
      },

    },

  }
</script>

<style scoped>

  .inputBoxWrap{background: #F6F8F7;padding: 3vw 3vw 2vw;border-radius: 1px;}
  .inputBoxWrap label{display: block;color:#869A95;font-size:  4vw;}
  /deep/input{display: block;color:#222721;font-size: 5vw;padding: 1.6vw 0
  ;background: transparent;border: 0;width: 100%;}
  .inputBoxWrap p{display: block;}
  /deep/.v-suggestions .items .item.is-active{background: #43AC35;color:white}
  /deep/.v-suggestions .items .item:hover{color:#0D5A44;}

  @media screen and (min-width: 760px) {
    .inputBoxWrap{margin-bottom: 0.6vw;padding: 1.5vw 1.1vw 1vw;}
    .inputBoxWrap label{font-size: 1.1vw;}
    /deep/input{font-size: 1.3vw;padding: 0.2vw 0;}
    .inputBoxWrap p{}
  }
  @media screen and (min-width: 1140px) {
    .inputBoxWrap{padding: 17px 13px 11px;margin-bottom: 7px;}
    .inputBoxWrap label{font-size:  12px;}
    /deep/input{font-size: 14px;padding: 2px 0;}
    .inputBoxWrap p{}
  }
</style>
